import { render, staticRenderFns } from "./PurchaseOrderTableItem.vue?vue&type=template&id=199e764f&scoped=true&"
import script from "./PurchaseOrderTableItem.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderTableItem.vue?vue&type=style&index=0&id=199e764f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199e764f",
  null
  
)

export default component.exports